import { useAxios } from "api/useAxios";
import { AxiosResponse } from "axios";
import { EndPoint } from "data/endPoint";
import { RipenessType } from "pages/Confirm/Confirm.type";
import { EstateResponse, ReconfirmResponse, RipenessResponse, UserResponse } from "types/feature/ripeness/ripeness";
import { pushQueryParams } from "utils/common-utils";

export const useRipeness = () => {
  const { api } = useAxios();

  //Picture 최초 조회
  const getValidPicture = async (ripeness: RipenessType, confirmed: boolean) => {
    return await api.get<RipenessResponse>(`${EndPoint.validPicture}?r=${ripeness}&confirmed=${confirmed}`);
  };

  //Picture 등록
  const putValidPicture = async (id: number, r: RipenessType, ripeness: RipenessType, userId: Number) => {
    return await api.put<RipenessResponse>(`${EndPoint.putvalidPicture}?r=${r}`, { id: id, ripeness: ripeness, userId: Number(userId) });
  };

  //Picture label
  const putLabelPicture = async (id: number, ripeness: RipenessType, userId: Number) => {
    return await api.put<RipenessResponse>(`${EndPoint.putvalidPicture}?r=${ripeness}`, { id: id, ripeness: ripeness, userId: userId });
  };

  //다음 Picture 조회
  const getNextValidPicture = async (id: number, ripeness: RipenessType, confirmed: boolean) => {
    return await api.get<RipenessResponse>(`${EndPoint.nextValidPicture.replace(":id", String(id))}?r=${ripeness}&confirmed=${confirmed}`);
  };

  //이전 Picture 조회
  const getPrevValidPicture = async (id: number, ripeness: RipenessType, confirmed: boolean) => {
    return await api.get<RipenessResponse>(`${EndPoint.prevValidPicture.replace(":id", String(id))}?r=${ripeness}&confirmed=${confirmed}`);
  };

  //Picture 삭제
  const deletePicture = async (id: number) => {
    return await api.delete<AxiosResponse>(`${EndPoint.deletePicture.replace(":id", String(id))}`);
  };

  //리컨펌 이미지 조회 (리컨펌 진행하지 않은 가장 오래된 이미지)
  const getReconfirmPicture = async (confirmed: boolean) => {
    return await api.get<ReconfirmResponse>(`${EndPoint.reconfirmPicture}?confirmed=${confirmed}`);
  };

  //리컨펌 수행 (리컨펌 저장처리 및 다음으로 리컨펌 진행하지 않은 가장 오래된 이미지 조회)
  const putReconfirmPicture = async (pictureId: number, ripeness: RipenessType, userId: number) => {
    return await api.put<ReconfirmResponse>(`${EndPoint.reconfirmPicture}`, { pictureId: pictureId, ripeness: ripeness, userId: userId });
  };

  //리컨펌 대상 이전 이미지 (리컨펌 완료와 관계 없음)
  const getPrevReconfirmPicture = async (id: number, confirmed: boolean) => {
    return await api.get<ReconfirmResponse>(`${EndPoint.prevReconfirmPicture.replace(":id", String(id))}?confirmed=${confirmed}`);
  };

  //리컨펌 대상 다음 이미지
  const getNextReconfirmPicture = async (id: number, confirmed: boolean) => {
    return await api.get<ReconfirmResponse>(`${EndPoint.nextReconfirmPicture.replace(":id", String(id))}?confirmed=${confirmed}`);
  };

  // // Picture 최초 조회 v2
  // const getValidPictureV2 = async () => {
  //   return await api.get<RipenessResponse>(`${EndPoint.validPicture}`);
  // }

  // 다음 Picture 조회 v2
  const getNextValidPictureV2 = async ({ id, estate, userId, inputName, date, isV3 }: { id: number; estate?: string; userId?: string; inputName?: string; date?: string; isV3?: boolean }) => {
    const url = pushQueryParams((isV3 ? EndPoint.v3NextValidPicture : EndPoint.nextValidPicture).replace(":id", String(id)), { estate, userId, name: inputName, createdDate: date });
    return await api.get<RipenessResponse>(url);
  };

  // 이전 Picture 조회 v2
  const getPrevValidPictureV2 = async ({ id, estate, userId, inputName, date, isV3 }: { id: number; estate?: string; userId?: string; inputName?: string; date?: string; isV3?: boolean }) => {
    const url = pushQueryParams((isV3 ? EndPoint.v3PrevValidPicture : EndPoint.prevValidPicture).replace(":id", String(id)), { estate, userId, name: inputName, createdDate: date });
    return await api.get<RipenessResponse>(url);
  };

  // Estate List 조회
  const getEstateList = async (version: string) => {
    return await api.get<EstateResponse>(`${EndPoint.estateList.replace(":version", version)}`);
    // return { estateList: ['Estate 1', 'Estate 2', 'Estate 3'] };
  };

  // Name List 조회
  const getUserList = async (version: string, estate?: string) => {
    const url = EndPoint.userList.replace(":version", version) + (estate ? `?estate=${estate}` : "");
    return await api.get<UserResponse>(url);
  };

  // valid picture 조회
  const getValidPictureV2 = async ({ isV3, estate, userId, inputName, date, model }: { isV3?: boolean; estate?: string; userId?: string; model?: string; inputName?: string; date?: string }) => {
    const url = pushQueryParams(isV3 ? EndPoint.v3ValidPicture : EndPoint.validPicture, { estate, userId, name: inputName, createdDate: date, model });
    return await api.get<RipenessResponse>(url);
  };

  return {
    getValidPicture,
    putValidPicture,
    getNextValidPicture,
    getPrevValidPicture,
    deletePicture,
    getReconfirmPicture,
    putReconfirmPicture,
    getPrevReconfirmPicture,
    getNextReconfirmPicture,
    putLabelPicture,

    getValidPictureV2,
    getNextValidPictureV2,
    getPrevValidPictureV2,
    getEstateList,
    getUserList,
  };
};
